export default {
  personalProfile: "Personal record",
  myAccount: "My account",
  back_to_my_account: "Back to my account",
  already_active: "Your account has already been activated. Please log in.",
};
